'use client';

import { useEffect } from 'react';
import { initOfflineSync } from '@/lib/offline';

/** Registers the offline service worker and starts the write-queue sync. */
export function ServiceWorkerRegistrar() {
  useEffect(() => {
    initOfflineSync();
    if (!('serviceWorker' in navigator)) return;

    // The offline SW is production-only: in dev it caches HTML/RSC and serves
    // stale pages during Fast Refresh (network blips → cache fallback), which
    // looks like "my changes aren't showing". Unregister any worker a previous
    // dev session left behind so it stops intercepting fetches.
    if (process.env.NODE_ENV !== 'production') {
      void navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => void reg.unregister());
      });
      return;
    }

    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* offline support is progressive — the app works without it */
    });
  }, []);
  return null;
}
